// @flow
import Router from 'react-router-dom/BrowserRouter';

import routes from '@src/SideMenuRoutes';

export default () => {
  return (
    <Router>
      {routes}
    </Router>
  );
};
